import { useCartStore } from '~/stores/cartStore/cartStore';
import { type CartType } from '~/stores/cartStore/model';

export default function buildMagentoCheckoutUrl(
  type?: CartType,
  withOrigin: boolean = true
): string | undefined {
  const { $locale, $shopStore } = useNuxtApp();

  const cartStore = useCartStore();
  const url = useRequestURL();
  const theType = type || cartStore.activeCartType;
  const cart = cartStore.carts[theType];
  if (!cart) {
    return;
  }

  const urlSearchParams = new URLSearchParams([
    ['locale', $locale.value],
    ['store', $shopStore.value],
    ['type', theType.toString()],
    // we need to add the cart id to avoid improper caching in CDN
    ['cartId', cart.id]
  ]);

  // we need an absolut url to avoid vue router pushes.
  return `${
    withOrigin ? url.origin : ''
  }/api/magento/cart/redirect/?${urlSearchParams.toString()}`;
}
